import React from 'react';
// import * as _ from 'lodash';
import {Button, ButtonGroup} from 'react-bootstrap';
// import EditInputTypePopup from './popup/EditInputTypePopup';
import FontAwesome from 'react-fontawesome';

export default function CustomFieldTemplate(props) {

  const {id, classNames, label, help, required, description, errors, children, formContext, schema} = props;
  let requiredLabel = null;
  if (required) {
    requiredLabel = (<span className="text-red">*</span>);
  }
  const field = id.replace('root_', '', id);
  const group = schema.group;


  if (id === 'root') {
    return <div className={classNames}>
      {description}
      {children}
      {errors}
      {help}
      {formContext.editMode ?
          <button className={'badge badge-sm badge-info float-right'}
                  onClick={formContext.onEdit(group, '')}>
            <FontAwesome name={'plus'} /> เพิ่มฟิลด์
          </button>
          : ''}
    </div>;
  }
  // const Edit = () => {
  //   return (e) => {
  //
  //     let ui_type = 'ui:widget';
  //     let ui_value = 'text';
  //     if (this.state.uiSchema[type][field] &&
  //         this.state.uiSchema[type][field]['ui:field']) {
  //       ui_type = 'ui:field';
  //     }
  //     if (this.state.uiSchema[type][field] &&
  //         this.state.uiSchema[type][field][ui_type]) {
  //       ui_value = this.state.uiSchema[type][field][ui_type];
  //     }
  //     let columnSize = 6;
  //     let columnOffset = 0;
  //     _.each(this.state.uiSchema[type]['ui:layout'], item => {
  //       if (item[field]) {
  //         columnSize = item[field].md || 6;
  //         columnOffset = item[field].mdOffset || 0;
  //       }
  //     });
  //
  //     this.setState({
  //       inputTypePopup: true,
  //       editInputGroup: type,
  //       editInputName: field,
  //       editInputSize: columnSize,
  //       editInputOffset: columnOffset,
  //       editInputLabel: this.state.schema[type].properties[field].title,
  //       editInputType: `${ui_type}|${ui_value}`,
  //       editInputRequired: _.indexOf(this.state.schema[type].required,
  //           field) !== -1,
  //     });
  //   };
  // };

  const renderField = () => {

    return (
        <div className={classNames}>
          <div>
            <label htmlFor={id}>
              {label}
              {requiredLabel}
            </label>
          </div>
          {description}
          {children}
          {errors}
          {help}
        </div>
    );
  };

  const renderEditModeField = () => {

    return (
        <div className={classNames}>
          <div>
            <label htmlFor={id}>
              {label}
              {requiredLabel}
            </label>
          </div>
          {description}
          {children}
          {errors}
          {help}
          <div>
            <ButtonGroup>
              <Button bsStyle={'primary'} bsSize={'xsmall'}
                      title={'Edit this field'}
                      onClick={formContext.onEdit(group, field)}>
              <FontAwesome name={'edit'} />
              </Button>
              <Button bsStyle={'danger'} bsSize={'xsmall'}
                      title={'Remove this field'}
                      onClick={formContext.onRemove(group, field)}>
                <FontAwesome name={'remove'} />
              </Button>
              <Button bsStyle={'info'} bsSize={'xsmall'}
                      title={'Move item to before previous item or to last item in previous row if it\'s first child'}
                      onClick={formContext.onMoveBefore(group, field)}>
                <FontAwesome name={'arrow-left'} />
              </Button>
              <Button bsStyle={'warning'} bsSize={'xsmall'}
                      title={'Split into new row before this row'}
                      onClick={formContext.onSplitRow(group, field)}>
                <FontAwesome name={'sort'} />
              </Button>
              <Button bsStyle={'info'} bsSize={'xsmall'}
                      title={'Move item to after next item or to first item in next row if it\'s last child'}
                      onClick={formContext.onMoveAfter(group, field)}>
                <FontAwesome name={'arrow-right'} />
              </Button>
            </ButtonGroup>
            <div className={'clearfix'} />
          </div>
        </div>
    );
  };

  return formContext.editMode ? renderEditModeField() : renderField();
}



// WEBPACK FOOTER //
// ./src/component/element/workdoc/CustomFieldTemplate.js